import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export class DeviceAPI extends BasicsClass {
    public apiUrls: any = new Map([
        // ['forbideenUserAccount', {
        //     url: '/user/forbid',
        //     name: 'account-forbid',
        //     label: '账户封禁'
        // }],
        ['getDeviceTableList', {
            url: '/admin/product/lists',
            name: 'list',
            label: '列表'
        }],
        ['createBatchDeviceGateId', {
            url: '/admin/product/make',
            name: 'batch-create-device-gate-id',
            label: '批量生成设备ID'
        }]
        // ['getUserDetail', {
        //     url: '/admin/user/show',
        //     name: 'detail',
        //     label: '详情',
        //     // hidden: true
        // }]
    ])


    // // 设备列表
    public getDeviceTableList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('getDeviceTableList').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }

    // 批量生成设备ID
    public createBatchDeviceGateId(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls
  
        const url = apiUrls.get('createBatchDeviceGateId').url
  
        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
      }
    


}